import { render, staticRenderFns } from "./Comentarios.vue?vue&type=template&id=5c4256c2&scoped=true"
import script from "./Comentarios.vue?vue&type=script&lang=ts"
export * from "./Comentarios.vue?vue&type=script&lang=ts"
import style0 from "./Comentarios.vue?vue&type=style&index=0&id=5c4256c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4256c2",
  null
  
)

export default component.exports